import React from 'react';
import { useTranslation } from 'react-i18next';
import Select, { components } from 'react-select';

// 1. Выносим иконку и логику Option внутрь
const CheckIcon = () => (
	<svg width="14" height="11" viewBox="0 0 14 11" fill="none" style={{ marginLeft: '10px' }}>
		<path d="M1 5L5 9L13 1" stroke="#6C757D" strokeWidth="2" strokeLinecap="round" />
	</svg>
);

const CustomOption = (props) => (
	<components.Option {...props}>
		<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
			{props.label}
			{props.isSelected && <CheckIcon />}
		</div>
	</components.Option>
);

const CustomMenu = (props) => {
	return (
		<div className="custom-select-menu">
			<components.Menu {...props}>
				{props.children}
			</components.Menu>
		</div>
	);
};

export const globalSelectStyles = {
	control: (provided, state) => ({
		...provided,
		backgroundColor: '#f4f5f7',
		borderRadius: '10px',
		border: 'none',
		boxShadow: 'none',
		cursor: 'pointer',

		// Установка высоты
		height: '36px',
		minHeight: '36px',
		minWidth: '200px',

		'&:hover': {
			backgroundColor: '#ebedf0',
		},
	}),

	// Контейнер, где лежит текст или input
	valueContainer: (provided) => ({
		...provided,
		height: '36px',
		padding: '0 12px',
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'nowrap', // Текст не должен переноситься на новую строку
		overflow: 'hidden', // Скрываем то, что не поместилось
		minWidth: 0,
	}),
	
	// Контейнер с иконками (стрелочка)
	indicatorsContainer: (provided) => ({
		...provided,
		height: '36px',
	}),

	// Сама иконка стрелочки
	dropdownIndicator: (provided) => ({
		...provided,
		color: '#adb5bd',
		padding: '0 8px', // Уменьшаем padding, чтобы иконка не распирала контейнер
		'&:hover': {
			color: '#6c757d',
		}
	}),

	// Поле ввода (когда поиск включен)
	input: (provided) => ({
		...provided,
		margin: '0px',
		padding: '0px',
	}),

	// Текст выбранного значения
	singleValue: (provided) => ({
		...provided,
		margin: '0px',
	}),

	// --- Остальные стили без изменений ---
	menu: (provided) => ({
		...provided,
		borderRadius: '12px',
		padding: '3px',
		boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
		border: 'none',
		zIndex: 9999,
	}),
	option: (provided, state) => ({
		...provided,
		backgroundColor: state.isSelected ? '#e9ecef' : 'transparent',
		color: '#333',
		borderRadius: '8px',
		margin: '5px 0',
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: state.isSelected ? '#e9ecef' : '#f8f9fa',
		}
	}),
	indicatorSeparator: () => ({
		display: 'none',
	}),
};

// 3. Сам компонент-обертка
const CustomSelect = (props) => {
	const { t } = useTranslation()

	return (
		<Select
			placeholder=""
			getOptionLabel={(option) => option.name}
			getOptionValue={(option) => option.id}
			isClearable={true}
			{...props}
			styles={globalSelectStyles}
			components={{
				...props.components,
				Option: CustomOption,
				Menu: CustomMenu
			}}
			classNamePrefix="react-select"
			noOptionsMessage={() => t('list_empty')}
		/>
	);
};

export default CustomSelect;